import {Module} from "vuex";
import {RootState} from "@/store/types";
import { callStatistic } from "./statistic";

export const callModule: Module<any, RootState> = {
  modules: {
    callStatistic,
    // callTemplate,
    // callFilter,
  }
}